import {anyArray, dataMember, required, typedArray} from 'santee-dcts';
import { deserializers } from '../../core';
import * as moment from 'moment';
import { Acknowledgement } from '../../view-history';
import { SubjectNaturalKey } from '../../subjects';
import { Distance } from '../../shared';
import { EQueryStatus } from './e-query-status';
import { AgeInfo } from '../age-info';

export abstract class ExternalUserEQuery implements AgeInfo {
    @required()
    @dataMember()
    public accessionNumber: string;

    @required()
    @dataMember()
    public eQueryId: number;

    @required()
    @dataMember()
    public eQueryStatus: EQueryStatus;

    @required()
    @dataMember()
    public eQueryAge: Distance;

    @required()
    @dataMember()
    public subjectId: number;

    @required({ nullable: true })
    @dataMember()
    public subjectInitials: string;

    @required({ nullable: true })
    @dataMember()
    public protocolVisitCode: string;

    @required({ nullable: true })
    @dataMember()
    public screeningNumber: string;

    @required({ nullable: true })
    @dataMember()
    public subjectNumber: string;

    @required({ nullable: true })
    @dataMember()
    public subjectNaturalKey: string;

    @required({ nullable: true })
    @dataMember({ customDeserializer: deserializers.deserializeDate })
    public visitCollectionDate: moment.Moment;

    @required({ nullable: true })
    @dataMember()
    public visitName: string;

    @dataMember()
    @typedArray(Acknowledgement)
    @required()
    public viewHistory: Acknowledgement[];

    @dataMember()
    @required()
    public isRead: boolean;

    @dataMember()
    @required()
    public isReadByMe: boolean;

    @dataMember()
    @required()
    public isUnresolved: boolean;

    @dataMember()
    @required({ nullable: true })
    @anyArray()
    public responders: string[];

    @dataMember({ customDeserializer: deserializers.deserializeDate })
    @required({ nullable: true })
    public responseDateTime: moment.Moment;

    public get zcSubjectId(): string | null {
        const result = SubjectNaturalKey.fromString(this.subjectNaturalKey);

        return result
            ? result.zcSubjectId
            : null;
    }
}
